/** Typed `?search` params for routes that carry state in the URL. */

export interface ViewSearch {
  /** Saved view id to run (`/queue?view=<uuid>`, `/board?view=<uuid>`). */
  view?: string;
  /** Project pinned by the queue/board filters (`?project=<uuid>`). */
  project?: string;
}

const nonEmpty = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

export function validateViewSearch(search: Record<string, unknown>): ViewSearch {
  return { view: nonEmpty(search.view), project: nonEmpty(search.project) };
}

export interface ProjectsSearch {
  includeArchived?: boolean;
}

export function validateProjectsSearch(search: Record<string, unknown>): ProjectsSearch {
  return {
    includeArchived:
      search.includeArchived === true || search.includeArchived === 'true' || undefined,
  };
}

export interface AutomationsSearch {
  /** Filters the tenant-wide `/automations` list to one project (Bolt 8). */
  project?: string;
}

export function validateAutomationsSearch(search: Record<string, unknown>): AutomationsSearch {
  return { project: nonEmpty(search.project) };
}
